<template>
  <div class="contract-apply-audit-orders-container">
    <template v-if="contractApplyAuditOrdersInfo.audit === '1'">
      <!-- (1) PageHeader -->
      <ds-page-header :title="$t('contractApplyAuditOrders.draftPendingList')" :subtitle="$t('contractApplyAuditOrders.page.subtitle')" />

      <!-- (3)(4)(6) Toolbar + DataTable + PaginationBar -->
      <div class="ds-panel">
        <ds-toolbar :total="page.total" :density="density" :show-column-setting="false" :show-refresh="true"
          @update:density="density = $event" @refresh="_listAuditOrders(page.current, page.size)">
          <template #left>
            <span class="ds-panel__title">{{ $t('contractApplyAuditOrders.draftPendingList') }}</span>
          </template>
        </ds-toolbar>

        <ds-data-table :data="contractApplyAuditOrdersInfo.contractApplyAuditOrders" :loading="loading"
          :error="hasError" :error-message="errorMessage" :density="density" border stripe
          :empty-description="$t('contractApplyAuditOrders.page.empty')"
          @retry="_listAuditOrders(page.current, page.size)">
          <el-table-column prop="contractCode" :label="$t('contractApplyAuditOrders.contractCode')" align="center" width="150">
            <template slot-scope="scope">
              <span class="ds-num">{{ scope.row.contractCode || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="contractName" :label="$t('contractApplyAuditOrders.contractName')" align="left" min-width="160" show-overflow-tooltip />
          <el-table-column prop="contractTypeName" :label="$t('contractApplyAuditOrders.contractType')" align="center" width="130" />
          <el-table-column prop="stateName" :label="$t('contractApplyAuditOrders.contractStatus')" align="center" width="120">
            <template slot-scope="scope">
              <ds-status-tag :label="scope.row.stateName" :text="scope.row.stateName" type="info" />
            </template>
          </el-table-column>
          <el-table-column prop="signingTime" :label="$t('contractApplyAuditOrders.createTime')" align="center" width="160">
            <template slot-scope="scope">
              <span class="ds-num">{{ scope.row.signingTime || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('contractApplyAuditOrders.operation')" align="center" width="220" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="_openDetailContractApplyModel(scope.row)">
                {{ $t('contractApplyAuditOrders.view') }}
              </el-button>
              <el-button v-if="scope.row.hasAudit && !scope.row.hasEnd" size="mini" type="text"
                @click="_openAuditOrderModel(scope.row)">
                {{ $t('contractApplyAuditOrders.audit') }}
              </el-button>
              <el-button v-if="scope.row.hasEnd" size="mini" type="text" class="ds-btn-warning" @click="_finishAuditOrder(scope.row)">
                {{ $t('contractApplyAuditOrders.finish') }}
              </el-button>
            </template>
          </el-table-column>
        </ds-data-table>

        <ds-pagination-bar :total="page.total" :page="page.current" :size="page.size"
          :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </template>
    <flow-audit v-else ref="flowAudit" @auditSubmit="handleAuditSubmit" @goBack="handleGoBack" />
  </div>
</template>

<script>
import { queryContractTask, needAuditContract, listWorkflowStepStaffs } from '@/api/contract/contractApplyAuditOrdersApi'
import { getCommunityId } from '@/api/community/communityApi'
import FlowAudit from '@/components/contract/flowAudit'
import { getUserId } from '@/api/user/userApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsPaginationBar from '@/components/ds/ds-pagination-bar.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'ContractApplyAuditOrdersList',
  components: {
    FlowAudit,
    DsPageHeader,
    DsToolbar,
    DsDataTable,
    DsPaginationBar,
    DsStatusTag
  },
  data() {
    return {
      loading: false,
      hasError: false,
      errorMessage: '',
      density: 'default',
      contractApplyAuditOrdersInfo: {
        contractApplyAuditOrders: [],
        total: 0,
        records: 1,
        currentUserId: '',
        conditions: {
          AuditOrdersId: '',
          userName: '',
          auditLink: ''
        },
        orderInfo: {},
        procure: false,
        audit: '1'
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.contractApplyAuditOrdersInfo.currentUserId = getUserId()
    this._listAuditOrders(this.page.current, this.page.size)
    this._loadStepStaff()
  },
  methods: {
    handleGoBack() {
      this.contractApplyAuditOrdersInfo.audit = '1'
      this._listAuditOrders(this.page.current, this.page.size)
    },
    handleAuditSubmit(auditInfo) {
      this._auditOrderInfo(auditInfo)
    },
    async _listAuditOrders(page, rows) {
      try {
        this.loading = true
        this.hasError = false
        this.errorMessage = ''
        this.contractApplyAuditOrdersInfo.audit = '1'
        const params = {
          page: page,
          row: rows,
          ...this.contractApplyAuditOrdersInfo.conditions
        }
        const { data, total, records } = await queryContractTask(params)
        this.contractApplyAuditOrdersInfo.contractApplyAuditOrders = Array.isArray(data) ? data : []
        this.contractApplyAuditOrdersInfo.total = total || 0
        this.contractApplyAuditOrdersInfo.records = records
        this.page.total = total || 0
      } catch (error) {
        console.error('请求失败:', error)
        this.hasError = true
        this.errorMessage = error.message || this.$t('contractApplyAuditOrders.page.loadFailed')
      } finally {
        this.loading = false
      }
    },
    _openAuditOrderModel(auditOrder) {
      this.contractApplyAuditOrdersInfo.orderInfo = auditOrder
      this.contractApplyAuditOrdersInfo.audit = '2'
      this.$refs.flowAudit.open(auditOrder)
    },
    _openDetailContractApplyModel(auditOrder) {
      this.$router.push(`/views/contract/contractApplyDetail?contractId=${auditOrder.contractId}`)
    },
    async _auditOrderInfo(auditInfo) {
      try {
        auditInfo.taskId = this.contractApplyAuditOrdersInfo.orderInfo.taskId
        auditInfo.contractId = this.contractApplyAuditOrdersInfo.orderInfo.contractId
        await needAuditContract(auditInfo)
        this.$message.success(this.$t('common.operationSuccess'))
        this._listAuditOrders(this.page.current, this.page.size)
      } catch (error) {
        this.$message.error(this.$t('common.handleFailed') + error.message)
      }
    },
    async _finishAuditOrder(auditOrder) {
      try {
        const auditInfo = {
          taskId: auditOrder.taskId,
          contractId: auditOrder.contractId,
          state: '1200',
          remark: this.$t('contractApplyAuditOrders.processEnd')
        }
        await needAuditContract(auditInfo)
        this.$message.success(this.$t('common.operationSuccess'))
        this._listAuditOrders(this.page.current, this.page.size)
      } catch (error) {
        this.$message.error(this.$t('common.handleFailed') + error.message)
      }
    },
    async _loadStepStaff() {
      try {
        const params = {
          page: 1,
          row: 1,
          staffId: this.contractApplyAuditOrdersInfo.currentUserId,
          staffRole: '2002'
        }
        const { data } = await listWorkflowStepStaffs(params)
        if (data.length > 0) {
          this.contractApplyAuditOrdersInfo.procure = true
        }
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    handleSizeChange(val) {
      this.page.size = val
      this.page.current = 1
      this._listAuditOrders(this.page.current, val)
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listAuditOrders(val, this.page.size)
    }
  }
}
</script>

<style lang="scss" scoped>
.contract-apply-audit-orders-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}

.ds-btn-warning {
  color: var(--ds-warning, #e6a23c) !important;
}
</style>
